import React from 'react'
import SaleTableBody from './sale'
import TableHeader from '../../../../CommonComponent/ListingScreens/TableHeader';
import NoSearchScreen from '../../../../CommonComponent/ListingScreens/NoSearchScreen';
import EmptyScreen from '../../../../CommonComponent/ListingScreens/EmptyScreen';
import TableShimmer from '../../../../CommonComponent/ListingScreens/TableShimmer';

export default function SalesTable({sales,loader, fetchHandler, handleSort, 
    currentSortColumn, searchParam,searchValue, loading,salesInfo,
    isSearched, auctionData, isFilterApplied, onChangePaymentInfo}) {

    const columns = [
        { label: "Order no.", sortKey: "order_number", testId: "sort-lot-number", id: "order_no", 
            minWidth: "140px", center: true },
        { label: "Customer name", sortKey: "name", testId: "sort-lot-number", id: "customer_name", 
            minWidth: "170px", center: true },
        { label: "Auction Name", minWidth: "170px", center: true },
        { label: "Date", sortKey: "created_at", testId: "sort-title", id: "date", minWidth: "130px", center: true },
        { label: "Total", sortKey: "amount", id: "total", minWidth: "160px", center: true },
        { label: "Payment type", sortKey: "payment", id: "payment_type", minWidth: "170px", center: true },
        { label: "Payment status", sortKey: "payment_status", id: "payment_status", minWidth: "170px", center: true },
        { label: "", minWidth: "60px" }
    ];

    return (
        <div className="md:pb-[70px] pb-[100px] pt-2 overflow-auto">
            <div className="z-10 border-[#DEDEDE] border rounded-lg xl:w-full w-fit">    
                
                <table aria-label="Outside Table" className="w-full overflow-auto table-auto">
                    <TableHeader currentSortColumn={currentSortColumn} handleSort={handleSort} columns={columns} />
                    {/* <!-- empty auction list --> */}
                    {!loading ?<tbody>
                        {sales.length>0?
                            <>
                                <SaleTableBody 
                                    sales={sales} auctionData={auctionData} salesInfo={salesInfo} searchParam={searchParam}
                                    onChangePaymentInfo={onChangePaymentInfo}
                                />
                            </>
                            :
                            <>
                                {searchValue!=='' && !isFilterApplied && searchParam.get('keyword')!==null ?
                                    <NoSearchScreen searchValue={searchValue} cols={7} />
                                    :
                                    salesInfo.total_orders===0 && !isFilterApplied &&
                                    <EmptyScreen message="Currently no sales" cols={7} />
                                }
                                {isFilterApplied && sales.length==0 && searchValue==='' &&
                                    <EmptyScreen message="No results for applied filter" cols={7} />
                                }
                                {searchValue!==''&& isFilterApplied && sales.length==0 && 
                                    <EmptyScreen message="No results found" cols={7} />
                                }
                            </>}
                    </tbody> : <tbody className="mt-5">
                        <TableShimmer columns={columns} rowCount={5} />
                    </tbody>}
                </table>
            </div>
        </div>
    )
}